import { BACKEND_URL } from "../../constants/ApplicationConstants";

export function getFilesByIdURL(id) {
    return BACKEND_URL + `/api/v1/download/filesById/${id}`;
}